<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Agriculture Clinic/ Products by Type Report
          </h2>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field label="ປະເພດສິນຄ້າ">
            <table class="table is-fullwidth is-narrow is-small">
              <thead>
                <tr>
                  <th class="has-text-centered " width="5%">#</th>
                  <th class="has-text-left " width="25%">
                    ປະເພດ
                  </th>
                  <th class="has-text-right " width="15%">
                    ຈຳນວນສິນຄ້າ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in activeproducts" :key="data.TYPEID">
                  <td class="has-text-centered">{{ index + 1 }}</td>
                  <td class="has-text-left ">
                    {{ data.TYPENAME }}
                  </td>
                  <td class="has-text-right ">
                    {{ data.PRODUCTS }}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-field>
        </div>
        <div class="column"></div>
      </div>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,
      // selectedType: null,
      // typeList: [],

      // selectedFile: null,
      // url: "uploadimage", // function name in api site
      // photoname: null,
      // photopath:
      //   process.env.NODE_ENV === "production"
      //     ? "https://agrilao.com/manager-main/api/uploads/products/"
      //     : "http://localhost/manager/api/uploads/products/",
      // // photopath: process.env.NODE_ENV === "production" ? "http://51.222.85.54/agrilao-manager/api/uploads/products/" : "http://localhost/agrilao-manager/api/uploads/products/",
      // photopreview: null,
      // isSelectPhoto: false,

      // selectedTypeSearch: null,
      // search: null,
      // selectedMonth: null,
      // MonthList: [
      //   { ID: "01", NAME: "01" },
      //   { ID: "02", NAME: "02" },
      //   { ID: "03", NAME: "03" },
      //   { ID: "04", NAME: "04" },
      //   { ID: "05", NAME: "05" },
      //   { ID: "06", NAME: "06" },
      //   { ID: "07", NAME: "07" },
      //   { ID: "08", NAME: "08" },
      //   { ID: "09", NAME: "09" },
      //   { ID: "10", NAME: "10" },
      //   { ID: "11", NAME: "12" },
      //   { ID: "12", NAME: "12" },
      // ],

      // productList: [],
      // selectedProductSearch: null,
      activeproducts: [],
    };
  },
  methods: {
    geyProductGroupbyType() {
      this.selectedProductSearch = null;
      this.selectedMonth = null;

      RestAPI.getClinicProductGroupbyType()
        .then((res) => {
          this.activeproducts = res.data;
          // console.log("res: " + JSON.stringify(res.data));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;

    // this.getAllProductivity();
    this.geyProductGroupbyType();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.preproductionstep {
  height: 35px;
}
</style>
